module.exports = __webpack_public_path__ + "static/media/no-photo-available.b112b5db.png";